import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import "./index.css";
import Flow43_4Table from "./Table";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
import { ShowHide } from "../../components/ShowHideProduct";

const Flow43_4 = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;

  return (
    <div className="prod-component-contents">
      <SubHeaderBox
        subTitle={t("SURPLUS_MATERIALS_GENERATED_43_4") || "Surplus materials generated in this category"}
        subDescription={t("SURPLUS_MATERIALS_GENERATED_43_4_DESC") || "Surplus materials generated during end-of-life transportation and processing."}
        isNormal={true}
        number={"43.4"}
        showSystemBoundary={false}
      />
      <ShowHide show={showTable} setShow={setShowTable} />
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`flow-43-4-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <Flow43_4Table productId={productId} />
        </TableLoadingWrapper>
      )}
    </div>
  );
};

export default Flow43_4;

